const sortServices = (services = [], priority = []) => {
  return priority.map(item => services.find(service => Number(service == null ? void 0 : service.id) === item));
};

export default sortServices;